export default Object.keys(process.env).reduce(
  (config, key) => ({ ...config, [key.replace('REACT_APP_', '')]: process.env[key] }),
  {},
)
